/* Mountain Face — comportamentos leves do tema (galeria, paginação das vitrines, guia de tamanhos).
   Carrinho, variantes, busca e quick add são os componentes nativos do Horizon. */
(function () {
  'use strict';

  function init(root) {
    root = root || document;

    /* setas da galeria da PDP */
    root.querySelectorAll('[data-mf-gal]').forEach(function (wrap) {
      if (wrap.dataset.mfReady) return;
      wrap.dataset.mfReady = '1';
      var gal = wrap.querySelector('.gz-gal');
      var prev = wrap.querySelector('[data-mf-prev]');
      var next = wrap.querySelector('[data-mf-next]');
      if (!gal) return;
      function step(dir) {
        var item = gal.querySelector('.gz-gal__item');
        var w = item ? item.getBoundingClientRect().width + 8 : gal.clientWidth * 0.42;
        gal.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
    });

    /* "1 / 4" + bolinhas das vitrines */
    root.querySelectorAll('[data-mf-vitrine]').forEach(function (sec) {
      if (sec.dataset.mfReady) return;
      sec.dataset.mfReady = '1';
      var trilho = sec.querySelector('.gz-vit__trilho');
      var pag = sec.querySelector('.gz-vit__pag');
      if (!trilho || !pag) return;
      function render() {
        var cw = trilho.clientWidth; if (!cw) { pag.style.display = 'none'; return; }
        var pages = Math.min(20, Math.max(1, Math.ceil(trilho.scrollWidth / cw)));
        var cur = Math.min(pages, Math.round(trilho.scrollLeft / cw) + 1);
        var html = '<span>' + cur + ' / ' + pages + '</span>';
        for (var i = 1; i <= pages; i++) html += '<i' + (i === cur ? ' class="on"' : '') + '></i>';
        pag.innerHTML = html;
        pag.style.display = pages > 1 ? '' : 'none';
      }
      trilho.addEventListener('scroll', render, { passive: true });
      window.addEventListener('resize', render);
      render();
    });

    /* guia de tamanhos */
    root.querySelectorAll('[data-mf-size-open]').forEach(function (a) {
      if (a.dataset.mfReady) return;
      a.dataset.mfReady = '1';
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var dlg = document.getElementById(a.getAttribute('data-mf-size-open'));
        if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      });
    });
    root.querySelectorAll('dialog.mf-dialog').forEach(function (dlg) {
      if (dlg.dataset.mfReady) return;
      dlg.dataset.mfReady = '1';
      dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      var x = dlg.querySelector('[data-mf-close]');
      if (x) x.addEventListener('click', function () { dlg.close(); });
    });

    /* ordenação da coleção */
    root.querySelectorAll('[data-mf-sort]').forEach(function (sel) {
      if (sel.dataset.mfReady) return;
      sel.dataset.mfReady = '1';
      sel.addEventListener('change', function () {
        var url = new URL(location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        location.href = url.toString();
      });
    });
  }

  /* acordeões da PDP (botão + painel; sem <details>, que apps de terceiros reescrevem) */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.gz-acc__t');
    if (!t) return;
    var open = t.getAttribute('aria-expanded') === 'true';
    t.setAttribute('aria-expanded', open ? 'false' : 'true');
    var p = t.nextElementSibling;
    if (p) p.hidden = open;
  });

  /* "Continue shopping" dentro do carrinho: fecha o drawer nativo */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.mf-prog__cont');
    if (!b) return;
    e.preventDefault();
    var dlg = document.getElementById('cart-drawer');
    if (dlg && typeof dlg.close === 'function' && dlg.open) { dlg.close(); return; }
    var x = document.querySelector('cart-drawer-component .theme-drawer__close-button, #cart-drawer .theme-drawer__close-button');
    if (x) x.click();
  });

  /* breadcrumb acompanha o título da PDP (inclusive quando um app troca o H1 depois do load) */
  (function () {
    var h1 = document.querySelector('.gz-info h1'), bc = document.querySelector('[data-mf-bc-title]');
    if (!h1 || !bc || !('MutationObserver' in window)) return;
    var sync = function () { var t = h1.textContent.trim(); if (t && bc.textContent.trim() !== t) bc.textContent = t; };
    new MutationObserver(sync).observe(h1, { childList: true, characterData: true, subtree: true });
    setTimeout(sync, 1500); setTimeout(sync, 4000);
  })();

  /* "Add one more" no carrinho: quando o visitante veio do link do anúncio, usa os dados brandados
     que o Guardians já expõe (window.PHANTOM_DATA), com a 2ª foto pra não repetir a do card. */
  function mfPhantomOn() {
    try { if (new URL(location.href).searchParams.has('utm_phantom')) return true; } catch (e) {}
    try { return !!(sessionStorage.getItem('phantom_swap_token') || '').trim(); } catch (e) { return false; }
  }
  function mfUpsellSwap() {
    if (!mfPhantomOn()) return;
    var data = window.PHANTOM_DATA; if (!data || !data.items) return;
    document.querySelectorAll('[data-mf-up][data-handle]').forEach(function (row) {
      var real = data.items[row.getAttribute('data-handle')]; if (!real) return;
      var t = row.querySelector('[data-mf-up-title]'); if (t && real.title && t.textContent !== real.title) t.textContent = real.title;
      var img = row.querySelector('[data-mf-up-img]'); var pick = real.images && (real.images[1] || real.images[0]);
      if (img && pick && pick.src && img.getAttribute('src') !== pick.src) { img.removeAttribute('srcset'); img.src = pick.src; }
    });
  }
  if (mfPhantomOn()) {
    var mfTries = 0, mfTimer = setInterval(function () { mfUpsellSwap(); if (++mfTries > 40) clearInterval(mfTimer); }, 500);
    var mfDrawer = document.querySelector('cart-drawer-component');
    if (mfDrawer && 'MutationObserver' in window) new MutationObserver(function () { mfUpsellSwap(); }).observe(mfDrawer, { childList: true, subtree: true });
    document.addEventListener('cart:update', mfUpsellSwap);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* editor de temas: seção recarregada */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
/* ORVANO — countdown evergreen (prazo por visitante, guardado no navegador) */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }
  function arm(el) {
    if (el.dataset.ovReady) return; el.dataset.ovReady = '1';
    var horas = parseInt(el.dataset.horas || '8', 10), minutos = parseInt(el.dataset.minutos || '0', 10);
    var key = 'ov_deadline_' + horas + '_' + minutos, end = 0;
    try { end = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
    if (!end || end < Date.now()) { end = Date.now() + horas * 3600e3 + minutos * 60e3; try { localStorage.setItem(key, String(end)); } catch (e) {} }
    var d = el.querySelector('[data-ov-d]'), h = el.querySelector('[data-ov-h]'), m = el.querySelector('[data-ov-m]'), s = el.querySelector('[data-ov-s]');
    function tick() {
      var r = Math.max(0, end - Date.now());
      if (r === 0) { end = Date.now() + horas * 3600e3 + minutos * 60e3; try { localStorage.setItem(key, String(end)); } catch (e) {} r = end - Date.now(); }
      if (d) d.textContent = pad(Math.floor(r / 864e5));
      if (h) h.textContent = pad(Math.floor(r % 864e5 / 36e5));
      if (m) m.textContent = pad(Math.floor(r % 36e5 / 6e4));
      if (s) s.textContent = pad(Math.floor(r % 6e4 / 1e3));
    }
    tick(); setInterval(tick, 1000);
  }
  function init(root) { (root || document).querySelectorAll('[data-ov-countdown]').forEach(arm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ORVANO — "Quedan N unidades": número próprio por produto, cai devagar enquanto a pessoa está na página, guardado no navegador */
(function () {
  function arm(el) {
    if (el.dataset.ovReady) return; el.dataset.ovReady = '1';
    var pid = el.dataset.pid, n0 = parseInt(el.dataset.n, 10) || 5, piso = parseInt(el.dataset.min, 10) || 2, base = parseInt(el.dataset.base, 10) || 30, cada = (parseInt(el.dataset.cada, 10) || 75) * 1000, txt = el.dataset.txt || 'Quedan [n] unidades';
    var p = el.querySelector('.ov-stock'), bar = el.querySelector('.ov-stock__bar i');
    var key = 'ov_stock_' + pid, st = null;
    try { st = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) {}
    if (!st || st.n0 !== n0) st = { n0: n0, n: n0, t: Date.now() };
    /* tempo que passou desde a última visita também conta, mas devagar (1 a cada 6h fora da página) */
    var fora = Math.floor((Date.now() - st.t) / (6 * 3600e3));
    if (fora > 0) { st.n = Math.max(piso, st.n - fora); st.t = Date.now(); }
    function paint() {
      if (p) p.textContent = txt.replace('[n]', st.n);
      if (bar) bar.style.width = Math.max(4, Math.round(st.n * 100 / base)) + '%';
      try { localStorage.setItem(key, JSON.stringify(st)); } catch (e) {}
    }
    paint();
    var jitter = cada * (0.8 + Math.random() * 0.5);
    function tick() {
      if (document.hidden) { setTimeout(tick, 5000); return; }
      if (st.n > piso) { st.n -= 1; st.t = Date.now(); paint(); }
      setTimeout(tick, cada * (0.8 + Math.random() * 0.5));
    }
    setTimeout(tick, jitter);
  }
  function init(root) { (root || document).querySelectorAll('[data-ov-stock]').forEach(arm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* ORVANO — depoimentos passando sozinhos, devagar; para quando o dedo/mouse está em cima */
(function () {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function arm(rail) {
    if (rail.dataset.ovReady) return; rail.dataset.ovReady = '1';
    var cards = Array.prototype.slice.call(rail.children);
    if (cards.length < 2) return;
    var track = document.createElement('div'); track.className = 'gz-rev__track';
    cards.forEach(function (c) { track.appendChild(c); });
    cards.forEach(function (c) { var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); track.appendChild(k); });
    rail.setAttribute('data-ov-marquee', ''); rail.appendChild(track);
    var x = 0, paused = false, last = null, speed = 28; /* px por segundo */
    rail.addEventListener('mouseenter', function () { paused = true; });
    rail.addEventListener('mouseleave', function () { paused = false; });
    rail.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    rail.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 1500); }, { passive: true });
    function frame(t) {
      if (last == null) last = t;
      var dt = (t - last) / 1000; last = t;
      if (!paused && !document.hidden) {
        x += speed * dt;
        var half = track.scrollWidth / 2;
        if (x >= half) x -= half;
        track.style.transform = 'translateX(' + (-x) + 'px)';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  function init(root) { (root || document).querySelectorAll('.gz-rev--verde .gz-rev__grid').forEach(arm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
